export const config = {"projectId":"journey-1c3de","databaseURL":"https://journey-1c3de.firebaseio.com","storageBucket":"journey-1c3de.appspot.com","locationId":"us-central","apiKey":"AIzaSyCIf7NmKxHv7FcALkApIm9tU9vcZoXlrus","authDomain":"journey-1c3de.firebaseapp.com","messagingSenderId":"802024518513"}


// WEBPACK FOOTER //
// ./src/configs/config-firebase.ts